<template>
  <form class="search-form" role="search" @submit.prevent>
    <label for="searchInput" class="visually-hidden">Search BVs</label>
    <input
        type="search"
        id="searchInput"
        v-model="searchValue"
        class="search-input"
        placeholder="Zoeken"
        aria-label="Search BVs"
        @input="emitSearch"
    />
    <img
        src="/assets/search-black.svg"
        class="search-icon"
        alt=""
        role="presentation"
    />
  </form>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'SearchBar',
  emits: ['search'],
  setup(_, { emit }) {
    const searchValue = ref('')

    const emitSearch = () => {
      emit('search', searchValue.value)
    }

    return {
      searchValue,
      emitSearch
    }
  }
})
</script>

<style scoped>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.search-form {
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  min-height: 46px;
  width: 221px;
  padding: 13px 8px;
  gap: 8px;
}

.search-input {
  border: none;
  background: transparent;
  flex: 1;
  font-size: 12px;
  color: var(--Neutral-8, #595c69);
  outline: none;
}

.search-icon {
  width: 20px;
  height: 20px;
}

@media (max-width: 991px) {
  .search-form {
    width: 100%;
  }
}
</style>